import { schema } from "normalizr";

const PromotionSchema = new schema.Entity("promotions");
const PromotionArraySchema = new schema.Array(PromotionSchema);

export { PromotionSchema, PromotionArraySchema };